module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/$.iterators.js
// module id = 21
// module chunks = 0